export async function getNouiSlider() {
    return import(/* webpackChunkName: "nouislider" */ 'nouislider').then(
        (noUiSlider) => ({
            noUiSlider,
        }),
    );
}
